// ═══════════════════════════════════════════════════════════════
// MÓDULO DE PROVISIONES LABORALES
// ═══════════════════════════════════════════════════════════════

import React, { useState } from 'react';
import { useCompany } from '../../../contexts/CompanyContext';
import ProvisionsDashboard    from './ProvisionsDashboard';
import ProvisionsEmployeeView from './ProvisionsEmployeeView';
import ProvisionsPayrollView  from './ProvisionsPayrollView';

const TABS = [
  { id: 'dashboard', label: 'Resumen General' },
  { id: 'employee',  label: 'Por Empleado'    },
  { id: 'payroll',   label: 'Por Nómina'      },
];

export default function ProvisionsModule() {
  const { currentCompany } = useCompany();
  const [activeTab, setActiveTab] = useState('dashboard');

  if (!currentCompany) {
    return (
      <div className="p-8 text-center text-gray-500">
        Selecciona una compañía para ver las provisiones.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
            <span className="text-amber-600 text-xl">📦</span>
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Provisiones Laborales</h1>
            <p className="text-sm text-gray-500">
              Acumulación mensual de regalía, vacaciones, cesantía y preaviso
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="mt-5 border-b border-gray-200">
          <nav className="flex gap-1 -mb-px">
            {TABS.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-5 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-amber-500 text-amber-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Contenido del tab activo */}
      {activeTab === 'dashboard' && (
        <ProvisionsDashboard companyId={currentCompany.id} />
      )}
      {activeTab === 'employee' && (
        <ProvisionsEmployeeView companyId={currentCompany.id} />
      )}
      {activeTab === 'payroll' && (
        <ProvisionsPayrollView companyId={currentCompany.id} />
      )}
    </div>
  );
}
